"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTINGS_VARIABLE = exports.ON_WIDGET_LOAD = exports.ON_READY_CALLBACKS = exports.ON_EXIT_INTENT = exports.GLOBAL_VARIABLE = void 0;
const GLOBAL_VARIABLE = exports.GLOBAL_VARIABLE = 'HubSpotConversations';
const ON_READY_CALLBACKS = exports.ON_READY_CALLBACKS = 'hsConversationsOnReady';
const SETTINGS_VARIABLE = exports.SETTINGS_VARIABLE = 'hsConversationsSettings';
const ON_EXIT_INTENT = exports.ON_EXIT_INTENT = 'ON_EXIT_INTENT';
const ON_WIDGET_LOAD = exports.ON_WIDGET_LOAD = 'ON_WIDGET_LOAD';